import { UserRoleEnum } from '@/types/auth.types';
import { SiderContentType } from '@/types/common.types';

import { ROUTES_PATH } from './routes.constants';

// const MATER_ROLES = [UserRoleEnum.sbf_master, UserRoleEnum.sbs_operation];

const SBS_ROLES = [
  UserRoleEnum.sbf_master,
  UserRoleEnum.sbs_operation,
  UserRoleEnum.sbs_sales,
  UserRoleEnum.sbs_tag_team,
];

export const SIDER_CONTENTS: SiderContentType[] = [
  {
    group: 'チェーン・店舗管理',
    routes: [
      {
        name: 'チェーン',
        path: ROUTES_PATH.organizationList,
        roles: SBS_ROLES,
      },
      {
        name: 'チェーン',
        path: ROUTES_PATH.myOrganization,
        roles: [UserRoleEnum.organization],
      },
      { name: '店舗・企画', path: ROUTES_PATH.shopList, roles: SBS_ROLES },
    ],
  },
  {
    group: '承認依頼',
    routes: [
      {
        name: '販売実績申請',
        path: ROUTES_PATH.salesResultsApplicationStatusList,
        roles: SBS_ROLES,
      },
      {
        name: '新店開業申請',
        path: ROUTES_PATH.shopApprovalRequestsList,
        roles: SBS_ROLES,
      },
    ],
  },
  {
    group: '販売実績',
    routes: [
      {
        name: '販売実績 申請状況',
        path: ROUTES_PATH.salesResultsApplication,
        roles: [UserRoleEnum.organization],
      },
      {
        name: '販売実績履歴',
        path: ROUTES_PATH.salesPerformanceHistoryList,
        roles: [...SBS_ROLES, UserRoleEnum.organization],
      },
    ],
  },
  {
    group: 'IPラベル',
    routes: [
      // { name: 'ラベルテンプレート管理', path: '4' },
      { name: '画像編集', path: ROUTES_PATH.bannerManagement },
      { name: 'ラベル編集', path: ROUTES_PATH.ipLabelList },
    ],
  },
  {
    group: 'フルデザインラベル',
    routes: [{ name: 'ラベル編集', path: ROUTES_PATH.fullIpLabelList }],
  },
  {
    group: 'ラベル表示順序',
    routes: [
      {
        name: '表示順序編集',
        path: ROUTES_PATH.labelOrderList,
        roles: [...SBS_ROLES, UserRoleEnum.organization],
      },
    ],
  },
  {
    group: 'スナップドリンク',
    routes: [
      {
        name: '販売情報・ラベル編集',
        path: ROUTES_PATH.snapLabelList,
        roles: [...SBS_ROLES, UserRoleEnum.organization],
      },
    ],
  },
  // {
  //   group: 'ドリンク管理',
  //   routes: [
  //     {
  //       name: 'ドリンクマスタ',
  //       path: ROUTES_PATH.drinkManagement,
  //       roles: MATER_ROLES,
  //     },
  //   ],
  // },
  {
    group: 'ドリンク',
    routes: [
      {
        name: '販売商品管理',
        path: ROUTES_PATH.shopDrinkList,
        roles: [UserRoleEnum.organization],
      },
    ],
  },
  {
    group: 'メンバー',
    routes: [
      {
        name: 'メンバー',
        path: ROUTES_PATH.accountList,
        roles: SBS_ROLES,
      },
    ],
  },
  {
    group: 'ヘルプ',
    routes: [
      { name: 'ご利用ガイド', path: ROUTES_PATH.usageGuide },
      { name: 'よくある質問', path: ROUTES_PATH.faq },
    ],
  },
];
